module.exports = __webpack_public_path__ + "img/banner.b324d541.png";